import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { CanRead } from '@/shared/components/security';
const SettingsSection = ({ title, children, defaultCollapsed = false, id, securityKey, }) => {
    const [collapsed, setCollapsed] = useState(defaultCollapsed);
    const content = (_jsxs("div", Object.assign({ className: "control-panel subsection", id: id }, { children: [_jsxs("div", Object.assign({ className: "title-block", onClick: () => setCollapsed(prev => !prev) }, { children: [_jsx("i", { className: `fa fa-inverse ${collapsed ? 'fa-chevron-down' : 'fa-chevron-up'}` }), _jsx("span", { children: title })] })), !collapsed && (_jsx("div", Object.assign({ className: "panel-body form-horizontal form-labels-left" }, { children: children })))] })));
    if (securityKey) {
        return _jsx(CanRead, Object.assign({ on: securityKey }, { children: content }));
    }
    return content;
};
export default SettingsSection;
